<ng-container *transloco="let t; read: 'authentication'">
    <h1>{{t('accessDenied.title')}}</h1>
    <span>{{t('accessDenied.message')}}</span>
</ng-container>